document.addEventListener('DOMContentLoaded', () => {
  // custom new tooltip in password
  setTimeout(() => {
    const tooltips = document.querySelectorAll('.bss-b2b-rf-tooltip');

    tooltips.forEach(tip => {
      const icon = tip.querySelector('.bss-b2b-rf-tooltip-icon');
      const textEl = tip.querySelector('.bss-b2b-rf-tooltip-text');
      if (!icon || !textEl) return;

      // Ẩn phần text gốc trong DOM (vì nó đang nằm dưới input)
      textEl.style.display = 'none';

      let floatingTooltip = null;

      icon.addEventListener('mouseenter', () => {
        // Tạo tooltip nổi
        floatingTooltip = document.createElement('div');
        floatingTooltip.className = 'bss-floating-tooltip';
        floatingTooltip.textContent = textEl.textContent;
        document.body.appendChild(floatingTooltip);

        const rect = icon.getBoundingClientRect();
        const top = rect.top + window.scrollY + rect.height / 2;
        const left = rect.right + 10 + window.scrollX;

        floatingTooltip.style.top = `${top}px`;
        floatingTooltip.style.left = `${left}px`;
        requestAnimationFrame(() => floatingTooltip.classList.add('show'));
      });

      icon.addEventListener('mouseleave', () => {
        if (!floatingTooltip) return;
        floatingTooltip.classList.remove('show');
        setTimeout(() => floatingTooltip?.remove(), 200);
      });
    });
  }, 2000);
});


if(typeof BSS_B2B != undefined) {
  if(window.location.pathname.includes("/pages/registratie")){
    setTimeout(() =>{
      let $lstField = $(".field");
      $lstField.addClass("relative mr-auto ml-auto mb-2.5");
      if ($lstField.length) {
        $lstField.each(function() {
          let $item = $(this);
          let $labelItem = $item.find("label");
          let $inputItem = $item.find("input");
          if ($labelItem.length && $inputItem.length) {
            $inputItem.after($labelItem);
            $inputItem.attr("required","");
            $inputItem.addClass("w-full input border rounded-none pl-5 pr-5 lg:pr-8 lg:pl-8 pt-5 pb-1 md:pt-5 md:pb-2 focus:outline-none focus:border-current bg-transparent placeholder:opacity-0");
            $labelItem.addClass("absolute top-1/2 left-5 lg:left-8 -translate-y-1/2 input_focus:text-xs input_focus:top-3.5 input_not_empty:top-3.5 input_not_empty:text-xs");
            $inputItem.attr("placeholder", " ");
          }
        });
      }

    function handleErrLastName(){
        const lstNameVal = $("#RegisterForm-LastName").val()
        return !!lstNameVal;
    }
    let spanError = $(`<span id="bss" class="bss-error-msg" style="color: #ff0000; text-align: center;display: block; margin: auto; margin-bottom: 15px;"><span class="bss-b2b-translation-rf-required_field" style="color: #ff0000">This field is required</span></span>`);
    $(`input[type="submit"]`).on("click", (e) => {
       if(!handleErrLastName()) {
           e.preventDefault();
           if($("#RegisterForm-LastName").parent().find(".bss-error-msg").length === 0) {
            $("#RegisterForm-LastName").after(spanError);
           }
           $([document.documentElement, document.body]).animate({
                    scrollTop: $("#RegisterForm-LastName").offset().top - 100
                }, 600);
       }
        
    }); 
          $(".rendered-form .form-group:not(.formbuilder-radio-group, .formbuilder-checkbox-group, .formbuilder-autocomplete)").each((ind, item) => {
        const input = $(item).find("input");
        const label = $(item).find("label");
        label && label.addClass("absolute top-1/2 left-5 lg:left-8 -translate-y-1/2 input_focus:text-xs input_focus:top-3.5 input_not_empty:top-3.5 input_not_empty:text-xs");
        input && input.addClass("w-full input border rounded-none pl-5 pr-5 lg:pr-8 lg:pl-8 pt-5 pb-1 md:pt-5 md:pb-2 focus:outline-none focus:border-current bg-transparent placeholder:opacity-0");
         input && input.removeClass("form-control")
        item && $(item).addClass("field")
        input && input.attr("placeholder", ' ');
        if(label && input) {
            input.after(label)
        }
    });
    $(".country-field").eq(0).addClass("w-full input border rounded-none pl-5 pr-5 lg:pr-8 lg:pl-8 pt-5 pb-1 md:pt-5 md:pb-2 focus:outline-none focus:border-current bg-transparent placeholder:opacity-0");
    $(".btn").addClass("button button-solid w-full block mr-auto ml-auto max-w-[570px] pt-2.5 pb-2.5 md:pt-3 md:pb-3 leading-normal mt-6 md:mt-9 mb-5")
      $("#text-1697186052069-0").attr("name", "confirm-pw")
    }, 200)
  }
  if(window.location.pathname.includes("/account")) { 
    setTimeout(() =>{
      let customerInformation = JSON.parse(localStorage.getItem('customerInformation'));
      if(customerInformation && customerInformation[20].value !== "Ja" ) {
          let shippingAddressTitle = $(".sa-title");
          let shippingAddressInfo = $(".sa-info");
          if(shippingAddressTitle && shippingAddressInfo) {
              shippingAddressTitle.css("display", "block");
              shippingAddressInfo.css("display", "block");
          }
      }
    }, 4000) 
  }
}

if (typeof BSS_B2B !== "undefined") {
  window.addEventListener("cart_changed", () => {
      BSS_B2B.cart.fixer(JSON.parse($("#bss-b2b-store-data").html()),null,false);
  })

  // handle addToCart
  setTimeout(() =>{
    let addToCart = $('button[type="submit"]');
    console.log({addToCart})
    if(addToCart) {
        addToCart.click(() =>{
            setTimeout(() =>{
              console.log(123)
                BSS_B2B.handleCartCheckoutBtn(JSON.parse($("#bss-b2b-store-data").html()));
            }, 1000)
        })
    }
  }, 3000);

  //fix hide pwc
  if(window.location.search.includes("?edit")) {
    setTimeout(()=>{
      const confirmPassword = $(".confirm-pw-field, .RegisterForm-password");
      if(confirmPassword.length) {
        confirmPassword.hide()
      }
    }, 200)
    
  }
}

document.addEventListener("bss_b2b_doneCheckCp", (function(t) {
  console.log("bss_b2b_doneCheckCp")
  BSS_B2B.handleCartCheckoutBtn(JSON.parse($("#bss-b2b-store-data").html()));
}))

if (typeof BSS_B2B !== "undefined") {
let timeBack = 30;
const handleF = () => {
  const target = $("#bss-checkout, button[type='submit'][name='add']");  
  let checkTime = 4;
  if (target.length > 0) {
    $("button[type='submit'], .cart-item__quantity").on("click", () => {
      let checkT = 4;
      const id = setInterval(() => {
        if ($("#bss-checkout").attr("style") === 'display: block;') {
          if (checkT-- === 0) clearInterval(id);
        }
        const defaultBtnCheckout = $("#bss-checkout").parent().find("button[name='checkout'], #checkout, .checkout-default, input[name='checkout']")
        if (defaultBtnCheckout.length > 0) {
            defaultBtnCheckout.css("display", "none");
            $("#bss-checkout").css("display", "block");
        }
      }, 500)
    })
  }
  else if (timeBack-- > 0){
    setTimeout(handleF, 300);
  }
}
handleF();
}
